var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ispc)?_c('div',{staticClass:"iframebox"},[_c('iframe',{staticStyle:{"width":"400px","height":"100vh"},attrs:{"id":"report-iframe","src":_vm.curURL,"frameborder":"0"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }